import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { Input, Stack, Box, Typography, useTheme, Button, IconButton} from "@mui/material";
import styled from "styled-components";
import { Link } from "react-scroll";

import InputBase from "@mui/material/InputBase";
import {Badge, theme} from "@material-ui/core";
import { useCollapse } from "react-collapsed";
// Components
import Sidebar from "../Nav/Sidebar";
import Backdrop from "../Elements/Backdrop";
// Assets
import LogoIcon from "../assets/svg/Logo";
import BurgerIcon from "../assets/svg/BurgerIcon";

import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";

import PhoneIcon from '@mui/icons-material/Phone';
import PasswordIcon from '@mui/icons-material/Password';
import LoginIcon from '@mui/icons-material/Login';
import LockIcon from '@mui/icons-material/Lock';

import SearchIcon from "@mui/icons-material/Search";
import urls from './../constants/urls';
import { ColorModeContext, tokens } from "./../theme";


export default function TopNavbar( { sendDataToParent } ) {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const colorMode = useContext(ColorModeContext);
    
    const [APIROOTURL, setAPIROOTURL]=useState(urls.rootAPIURL);
    
 const handleChangeInput = (e) =>{
  const {name, value } =e.target
  setFormDataUserLoginEXT({
   ...formDataUserLoginEXT,
   [name]: value
  })
  //
   
   //
   setErrors({});
 }


  const [y, setY] = useState(window.scrollY);
  const [sidebarOpen, toggleSidebar] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => setY(window.scrollY));
    return () => {
      window.removeEventListener("scroll", () => setY(window.scrollY));
    };
  }, [y]);
 
  const { getCollapseProps, getToggleProps, isExpanded } = useCollapse();

  
    const [formDataUserLoginEXT, setFormDataUserLoginEXT]=useState({
         
          users_id: 0,// = models.BigAutoField(primary_key=True)
          first_name: 'Default',// = models.CharField(max_length=32)
          middle_name: 'Default',// = models.CharField(max_length=32)
          last_name: 'Default',// = models.CharField(max_length=32)
          full_name: 'Default',// = models.CharField(max_length=64)
          gender: 'Default',// = models.CharField(max_length=16)
          mobile_number: '',// = models.CharField(max_length=16)
          user_email: 'Default',// = models.CharField(max_length=32)
          date_of_birth: '1980-01-01 00:00:00.000',// =models.DateTimeField(max_length=32, null=True)
          password_id: 0,// = models.IntegerField()
          user_password: '',// =models.CharField(max_length=128)
          login_category_id: 0,// = models.IntegerField()
          login_category_name: 'Default',// =models.CharField(max_length=32)
      })
    
    const [errors, setErrors]=useState({});
    
    
   const Login=()=>{
     
     
    //let url = API_URL;
    let APIURL= APIROOTURL + "UserLoginViewEXT"
    let picsId=0;
    axios
      .post(APIURL, formDataUserLoginEXT, {
        headers: {
          "Content-type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log("res.data.msg=" + res.data.msg)
        let usersId=res.data.usersId;
       let fullName=res.data.username; //res.data.fullName;
       
       console.log("res.data.fullName=" + res.data.fullName)
       // schoolDetails
       
       let schoolDetails=res.data.schoolDetails;
       
       console.log("res.data.schoolDetails.fullName=" + res.data.schoolDetails.schoolName)
       
       console.log("res.data.schoolDetails['schoolName']=" + res.data.schoolDetails['schoolName'])

       let loginCategoryName=res.data.category;
       let userRolesList=[];//res.data.qr;
      
       let loginDetails=res.data.loginDetails;
       
       let loginDetailsForm={
        loginCategory: loginCategoryName,
        
        userPassword: formDataUserLoginEXT['user_password'],
        fullName: fullName,
        usersId: usersId,
      }
                        //User login was successful
       if (res.data.msg==="User login was successful"){
        //loadUserRoles=(true, usersId, fullName, loginCategoryName)
        //alert("1");
        sendDataToParent(true, usersId, fullName, loginCategoryName, userRolesList, loginDetailsForm, schoolDetails, loginDetails);
        //console.log("2");
       }
       else{
        alert("Login failed");
       }
       //

      })
      .finally(() => {
       
    
      })
      .catch((err) => console.log(err));

   }   


     
const validateForm = (data) =>{
  const errors={};
  if(data.mobile_number==="" || data.mobile_number==""){
    console.log("if " + ", data.name=" + data.mobile_number)
    errors.mobile_number='Please enter mobile number';
   }
   else{
    console.log("else " + ", data.mobile_number=" + data.mobile_number)
   }

   if(data.user_password==="" || data.user_password==""){
    console.log("if " + ", data.name=" + data.user_password)
    errors.user_password='Please enter password';
   }
   else{
    console.log("else " + ", data.user_password=" + data.user_password)
   }
  
  return errors;

}

      

  const handleButtonSubmit = () =>{
    
    console.log("formDataUserLoginEXT.mobile_number=" + formDataUserLoginEXT['mobile_number'])
    console.log("formDataUserLoginEXT.user_password=" + formDataUserLoginEXT['user_password'])
     
     let newErrors=validateForm(formDataUserLoginEXT);
     setErrors(newErrors);
     
     console.log("errors.lenght=" + Object.keys(newErrors).length)
     if(Object.keys(newErrors).length===0){
       console.log("len0")
       Login()
     }
     else{
       console.log("len1")
     }
     /***
     
     ***/
 
 }
 

  return (
    <>
      <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      {sidebarOpen && <Backdrop toggleSidebar={toggleSidebar} />}
      <Wrapper className="flexCenter animate whiteBg" style={y > 100 ? { height: "80px" } : { height: "100px" }}>
        <NavInner className="container flexSpaceCenter">
          <Link className="pointer flexNullCenter" to="home" smooth={true}>
            <LogoIcon />
            <h1 style={{ marginLeft: "15px" }} className="font20 extraBold">
              EDUCATION TRIANGLE
            </h1>
          </Link>
          <BurderWrapper className="pointer" onClick={() => toggleSidebar(!sidebarOpen)}>
            <BurgerIcon />
          </BurderWrapper>
          <UlWrapper className="flexNullCenter">
            <li className="semiBold font15 pointer">
              <Link activeClass="active" style={{ padding: "10px 15px" }} to="home" spy={true} smooth={true} offset={-80}>
                Home
              </Link>
            </li>
            <li className="semiBold font15 pointer">
              <Link activeClass="active" style={{ padding: "10px 15px" }} to="services" spy={true} smooth={true} offset={-80}>
                Services
              </Link>
            </li>
            <li className="semiBold font15 pointer">
              <Link activeClass="active" style={{ padding: "10px 15px" }} to="projects" spy={true} smooth={true} offset={-80}>
                Schools
              </Link>
            </li>
            <li className="semiBold font15 pointer">
              <Link activeClass="active" style={{ padding: "10px 15px" }} to="blog" spy={true} smooth={true} offset={-80}>
                Ads
              </Link>
            </li>
            <li className="semiBold font15 pointer">
              <Link activeClass="active" style={{ padding: "10px 15px" }} to="pricing" spy={true} smooth={true} offset={-80}>
                Pricing
              </Link>
            </li>
            <li className="semiBold font15 pointer">
              <Link activeClass="active" style={{ padding: "10px 15px" }} to="contact" spy={true} smooth={true} offset={-80}>
                Contact
              </Link>
            </li>
          </UlWrapper>
          <UlWrapperRight className="flexNullCenter">
            <li className="semiBold font15 pointer">
              {/*** *
              <a href="/" style={{ padding: "10px 30px 10px 0" }}>
                Log in
              </a>
              ***/}

            <div>
              <a {...getToggleProps()}  style={{ padding: "5px 15px 5px 0" }}>
                {isExpanded ? "Close" : "Log in"}
              </a>
              <section {...getCollapseProps()}>
                {/***Collapsed content 🙈***/}
                <Stack direction="row" spacing={2} sx={{width: '320px', height: '40px'}}>
                <Box
            display="flex"
            backgroundColor={colors.primary[400]}
            borderRadius="3px"
            flex={12}
           >
            {/** *
            <IconButton type="button" sx={{ p: 1 }}>
              <PhoneIcon />
            </IconButton>
            ***/}
            <InputBase sx={{ ml: 2, flex: 1, fontSize: '12px', }} 
            placeholder="Mobile number" 
            name="mobile_number"
            onChange={handleChangeInput}
            />
            {/***{ errors.mobile_number && (<span> {errors.mobile_number} </span>)}***/}
          </Box>

          {/*** *
          </Stack>

          <Stack direction="row" spacing={2} sx={{width: '250px', height: '40px'}}>
           ***/ }
          <Box
            display="flex"
            backgroundColor={colors.primary[400]}
            borderRadius="3px"
            marginTop="20px"
            marginBottom="10px"
            flex={12}
           >
            {/*** *
            <IconButton type="button" sx={{ p: 1 }}>
              <PasswordIcon />
            </IconButton>
            ***/}
            <Input sx={{ ml: 2, flex: 1, fontSize: '12px', width: '100%'}} 
            type="password"
            name="user_password"
            placeholder="Password"
            onChange={handleChangeInput}


            />
            {/** *
            { errors.user_password && (<span> {errors.user_password} </span>)}
            ***/}
          </Box>

          <Button 
      type="Submit"  color="secondary" variant="contained"
       onClick={handleButtonSubmit}
       sx={{ width: '40px', marginLeft: '2px', marginTop: '10px'}}
       startIcon={<LoginIcon />}
       >
       LOGIN
      </Button>
                </Stack>
                </section>
            </div>

            </li>

            {/***
            <li className="semiBold font15 pointer flexCenter">
              <a href="/" className="radius8 lightBg" style={{ padding: "10px 15px" }}>
                Get Started
              </a>
            </li>
            ***/}
          </UlWrapperRight>
        </NavInner>
      </Wrapper>
    </>
  );
}

const Wrapper = styled.nav`
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
`;
const NavInner = styled.div`
  position: relative;
  height: 100%;
`
const BurderWrapper = styled.button`
  outline: none;
  border: 0px;
  background-color: transparent;
  height: 100%;
  padding: 0 15px;
  display: none;
  @media (max-width: 760px) {
    display: block;
  }
`;
const UlWrapper = styled.ul`
  display: flex;
  @media (max-width: 760px) {
    display: none;
  }
`;
const UlWrapperRight = styled.ul`
  @media (max-width: 760px) {
    display: none;
  }
`;


